var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "documents 1",
    clipPath: "url(#clip0_136_2679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.3984 2.01562C14.3984 1.00781 13.5781 0.1875 12.5703 0.1875H1.98438C0.976562 0.1875 0.15625 1.00781 0.15625 2.01562V37.9922C0.15625 39 0.976562 39.8203 1.98438 39.8203H38.0234C39.0312 39.8203 39.8516 39 39.8516 37.9922V5.66406C39.8516 4.65625 39.0312 3.83594 38.0234 3.83594H16.2266C15.2109 3.83594 14.3984 3.02344 14.3984 2.01562Z",
    fill: "#E39A61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M37.6484 7.89062H3.88281V22.5312H37.6484V7.89062Z",
    fill: "#CE8452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M36.8828 7.27344H3.11719V21.9141H36.8828V7.27344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M38.0156 14.5H36.1094V18.2344H35.4922V21.3047H17.5391V18.2344H16.5391V14.5H1.98438C0.976562 14.5 0.15625 15.3203 0.15625 16.3281V37.9922C0.15625 39 0.976562 39.8203 1.98438 39.8203H38.0234C39.0312 39.8203 39.8516 39 39.8516 37.9922V16.3281C39.8438 15.3203 39.0234 14.5 38.0156 14.5Z",
    fill: "#FBD984"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M38.0156 38.5391H1.98438C0.976562 38.5391 0.15625 37.7188 0.15625 36.7109V37.9844C0.15625 38.9922 0.976562 39.8125 1.98438 39.8125H38.0234C39.0312 39.8125 39.8516 38.9922 39.8516 37.9844V36.7109C39.8438 37.7188 39.0234 38.5391 38.0156 38.5391Z",
    fill: "#FDC77C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.8438 11.0156H5.73438V12.3359H17.8438V11.0156Z",
    fill: "#DBDFE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M35.5547 10.4141H18.1562V13.0234H35.5547V10.4141Z",
    fill: "#DBDFE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M36.1094 16.2422H17.2344V18.8516H36.1094V16.2422Z",
    fill: "#DBDFE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M26.6953 6.86719C21.5781 6.86719 17.4375 11.0156 17.4375 16.125C17.4375 21.2422 21.5859 25.3828 26.6953 25.3828C31.8047 25.3828 35.9531 21.2344 35.9531 16.125C35.9609 11.0078 31.8125 6.86719 26.6953 6.86719ZM26.6953 23.9531C22.375 23.9531 18.8672 20.4453 18.8672 16.125C18.8672 11.8047 22.375 8.29687 26.6953 8.29687C31.0156 8.29687 34.5234 11.8047 34.5234 16.125C34.5234 20.4453 31.0234 23.9531 26.6953 23.9531Z",
    fill: "#52AFA8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M20.5505 24.4932L18.3242 22.2668L16.5564 24.0346L18.7827 26.2609L20.5505 24.4932Z",
    fill: "#52AFA8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M34.7266 8.09375C30.2969 3.65625 23.1016 3.65625 18.6719 8.09375C14.2422 12.5312 14.2344 19.7188 18.6719 24.1484C23.1016 28.5859 30.2969 28.5859 34.7266 24.1484C39.1563 19.7188 39.1563 12.5312 34.7266 8.09375ZM32.9609 22.3828C29.5 25.8438 23.8984 25.8438 20.4375 22.3828C16.9766 18.9219 16.9766 13.3203 20.4375 9.85938C23.8984 6.39844 29.5 6.39844 32.9609 9.85938C36.4141 13.3203 36.4141 18.9297 32.9609 22.3828Z",
    fill: "#5AC8AE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M18.8438 26.3203L16.5 23.9844C16.1641 23.6484 15.6172 23.6484 15.2812 23.9844L9.53125 29.7344C8.54688 30.7188 8.54688 32.3125 9.53125 33.2969C10.5156 34.2813 12.1094 34.2813 13.0938 33.2969L18.8438 27.5469C19.1797 27.2031 19.1797 26.6562 18.8438 26.3203Z",
    fill: "#F1786B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_136_2679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.8936503c216a2c9a7fa5b6d96d2605ae.svg";
export { ForwardRef as ReactComponent };